/* File: faceHighlightBox.js
 * Path: ananunadm/src/helpers/faceHighlightBox.js
*/

// Face detection runs on a sharp .resize(800, 600, { fit: "inside" }) copy of
// the original (see ananunapi/services/faceRecognition.service.js), not the
// stored full-size image — so a saved boundingBox is in that resized copy's
// pixel space. To draw it over an image of any rendered size, recompute that
// same resize (from the upload's real width/height) and normalize the box to
// 0-1 fractions, which stay correct at any render size.
const DETECTION_RESIZE_CAP = { width: 800, height: 600 };

export const computeHighlightBox = (box, originalWidth, originalHeight) => {
	if (!box || !originalWidth || !originalHeight) return null;
	const scale = Math.min(DETECTION_RESIZE_CAP.width / originalWidth, DETECTION_RESIZE_CAP.height / originalHeight);
	const resizedWidth = originalWidth * scale;
	const resizedHeight = originalHeight * scale;
	if (!resizedWidth || !resizedHeight) return null;
	const width = (Number(box.width) || 0) / resizedWidth;
	const height = (Number(box.height) || 0) / resizedHeight;
	if (width <= 0 || height <= 0) return null;
	return {
		x: (Number(box.x) || 0) / resizedWidth,
		y: (Number(box.y) || 0) / resizedHeight,
		width,
		height
	};
};

export default computeHighlightBox;
